import initSkipNav from './components/skip-nav';

const skipNavEl = document.querySelector('.js-skip-nav');

if (skipNavEl) {
    initSkipNav(skipNavEl);
}
